/**
 * Formats cityStateDistance label for better readability
 * Replaces forward slash (/) with comma and space (, ) in location part
 * Example: "Dallas/TX:::25mi away" → "Dallas, TX:::25mi away"
 * @param {string} label - The raw cityStateDistance label
 * @returns {string|null} - Formatted label or original label if no formatting needed
 */
export const formatCityStateDistance = (label) => {
	if (!label) return null;

	const [locationPart, distancePart] = label.split(':::');
	if (locationPart && locationPart.includes('/')) {
		// Replace "/" with ", " for better readability (e.g., "Dallas/TX" → "Dallas, TX")
		const formattedLocation = locationPart.replace('/', ', ');
		return distancePart
			? `${formattedLocation}:::${distancePart}`
			: formattedLocation;
	}
	return label;
};
